import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';

const InputField = ({ label, width, name, call, defaultValue, type, onChange }) => {
  const [value, setValue] = useState(defaultValue || '');
  const [error, setError] = useState(false);
  const patterns = {
    name: /[^\p{L}\d\s]+/gu,
    email: /[^a-zA-Z0-9@._-]+/g,
    group: /[^\p{L}\d\s+()\-_]+/gu,
    default: null
  };

  const theme = useTheme();
  const secondaryColor = theme.palette.secondary.main;
  const hoverColor = theme.palette.secondary.light;
  const errorColor = theme.palette.error.main;

  useEffect(() => {
    if (defaultValue) setValue(defaultValue);
  }, [defaultValue])

  useEffect(() => {

    if (call && !value) setError(true);

  }, [call, value]);

  const handleInputChange = (event) => {
    const input = event.target.value.replace(patterns[type], '');

    setValue(input);
    setError(!input);

    onChange(event, input);
  };

  return (
    <TextField
      id='outlined-basic'
      inputProps={{ maxLength: 250 }}
      error={error}
      autoComplete='off'
      fullWidth
      label={label}
      required={true}
      variant='outlined'
      size='small'
      type='assunto'
      value={value}
      onChange={handleInputChange}
      name={name}
      sx={{
        width: width,
        '& fieldset': { borderColor: secondaryColor, borderRadius: '10px', },
        '& .MuiOutlinedInput-root': {
          '&:hover fieldset': {
            borderColor: error ? errorColor : hoverColor,
          },
          '&.Mui-focused fieldset': {
            borderColor:  error ? errorColor : secondaryColor
          }
        },
        '& .MuiInputLabel-shrink': {
          color: error ? errorColor : secondaryColor,
        },
      }}
    />
  );
};

export default InputField;